import React, { useContext } from 'react'
import {
    Stack,
    Box,
    Typography,
} from '@mui/material'

import { ThemeContext } from '../../context/theme/context.js'
import Header from '../../utils/header.js'
import useCursorHandlers from '../../hooks/cursor_handlers.js'
import CustomDivider from '../../utils/divider.js'

import data from '../../data/skills.json'

const Experience = () => {
    const { state } = useContext(ThemeContext)
    const cursorHandlers = useCursorHandlers()

    return <Box>
        <Header
            color={state.color.primary}
            title='SKILLS' />
        <Stack
            direction={{ xs: 'column' }}
            width="100%"
            spacing={{ xs: 1, sm: 2, md: 4 }}
            alignItems="flex-start"
            {...cursorHandlers}>
            {data.skills.map((skill, index) =>
                <Stack
                    key={index}
                    direction={{ xs: 'column' }}
                    width="100%"
                    position="relative">
                    <Stack
                        direction={{ xs: 'row' }}
                        width="100%"
                        p="2% 0%"
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        alignItems="flex-start"
                        justifyContent="flex-start">
                        <Typography
                            color={state.color.secondary}
                            fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                            sx={{
                                fontSize: { xs: 24, md: 52 },
                                fontWeight: 900,
                                letterSpacing: '0.05em',
                                // textAlign: 'center',
                                // textTransform: 'uppercase',
                                // '&:hover': {
                                //     color: state.color.primary
                                // }
                            }}
                        >
                            {skill.split(':')[0]}
                        </Typography>
                        <Typography
                            color={state.color.primary}
                            fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                            sx={{
                                fontSize: { xs: 24, md: 52 },
                                fontWeight: 900,
                                letterSpacing: '0.05em',
                                // textAlign: 'center',
                                // textTransform: 'uppercase',
                                // '&:hover': {
                                //     color: state.color.primary
                                // }
                            }}
                        >
                            {skill.split(':')[1]}
                        </Typography>
                    </Stack>
                    <CustomDivider />
                </Stack>
            )}
        </Stack >
    </Box >
}

export default Experience